import $ from 'jquery'

let loaded = false

export const loadBootstrapLegacy = async () => {
  if (loaded || typeof window === 'undefined') return

  window.$ = $
  window.jQuery = $

  await import('bootstrap/js/transition.js')
  await import('bootstrap/js/button.js')
  await import('bootstrap/js/collapse.js')
  await import('bootstrap/js/dropdown.js')
  await import('bootstrap/js/tab.js')

  loaded = true
}
